import React from "react";
import {
  Box,
  Typography,
} from "../ui";
import DismissButton from "../global/DismissButton";
import DialogBox from "../global/DialogBox";
import SnpButton from "../global/SnpButton";
import YouTubeVideo from "../global/YouTubeVideo";

const getYouTubeVideoId = (payload) => {
  if (payload.youtubeVideoId) return payload.youtubeVideoId;
  const value = payload.youtubeUrl || "";
  try {
    const url = new URL(value);
    if (url.hostname.includes("youtu.be")) return url.pathname.slice(1);
    return url.searchParams.get("v") || url.pathname.split("/").filter(Boolean).pop() || "";
  } catch (error) {
    return value;
  }
};

const GeneralNotificationDialog = ({ notification, onDismiss }) => {
  if (!notification) return null;

  const type = String(notification.type || "text").toLowerCase();
  const dismissible = notification.dismissible !== false
    && notification.dismissible !== "false"
    && notification.block !== true
    && notification.block !== "true";
  const handleClose = () => {
    if (dismissible) onDismiss();
  };
  const handleAction = () => {
    try {
      const actionUrl = new URL(notification.actionUrl, window.location.origin);
      if (!["http:", "https:"].includes(actionUrl.protocol)) return;
      window.open(actionUrl.href, notification.actionTarget || "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Invalid general notification action URL", error);
    }
  };

  if (type === "youtube") {
    return (
      <YouTubeVideo
        videoId={getYouTubeVideoId(notification)}
        dismissible={dismissible}
        onDismiss={handleClose}
      />
    );
  }

  const dialogContent = (
    <>
      {type === "image" && notification.imageUrl && (
        <Box
          component="img"
          src={notification.imageUrl}
          alt={notification.imageAlt || notification.title || "Notification"}
          sx={{ width: "100%", maxHeight: "60vh", objectFit: "contain", borderRadius: 1, mb: 2 }}
        />
      )}
      {notification.body && (
        <Typography sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
          {notification.body}
        </Typography>
      )}
    </>
  );

  const dialogActions = (dismissible || notification.actionUrl) ? (
    <>
      {notification.actionUrl && (
        <SnpButton variant="contained" onClick={handleAction}>
          {notification.actionLabel || "View Details"}
        </SnpButton>
      )}
      {dismissible && <DismissButton onClick={handleClose}>Dismiss</DismissButton>}
    </>
  ) : null;

  return (
    <DialogBox
      showDialog
      mFullWidth
      mwidth="sm"
      title={notification.title || "Notification"}
      dialogContent={dialogContent}
      dialogActions={dialogActions}
      outsideClickedDismiss={dismissible}
      onClose={handleClose}
    />
  );
};

export default GeneralNotificationDialog;
